// extracted by mini-css-extract-plugin
export default {"left":"ProfileTabs_left__sLqSS"};